import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function ContentSection() {
  const modules = ['Cómo hablar para que te escuche sin ponerse a la defensiva', 'Frases mágicas que calman conversaciones tensas al instante', "Cómo poner límites claros sin sonar agresiva ni 'loca'", 'Qué decir exactamente cuando estás emocional y a punto de explotar', 'Scripts para pedir lo que necesitas y que él quiera dártelo', "La técnica del 'Sandwich Emocional' para dar feedback difícil"];
  return <Section background="white" data-id="element-39">
      <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-40">
        Lo que encontrarás dentro del ebook
      </h2>

      <div className="bg-gray-50 rounded-2xl p-8 md:p-12 border border-gray-100" data-id="element-41">
        <ul className="grid gap-6 md:grid-cols-2" data-id="element-42">
          {modules.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-43">
              <div className="flex-shrink-0 h-6 w-6 rounded-full bg-green-100 flex items-center justify-center mt-1" data-id="element-44">
                <Check className="h-4 w-4 text-green-600" data-id="element-45" />
              </div>
              <span className="text-lg text-gray-700" data-id="element-46">{item}</span>
            </li>)}
        </ul>
      </div>
    </Section>;
}